export default __webpack_public_path__ + "d74ff1cdcede27b19cad1734d1fd8671.gif";